import './bookingactions.css';

const ExportBookingsCSV = ({ operators, bookings, bookingType, fileName }) => {
  const handleExport = () => {
    if (!bookings || bookings.length === 0) return;

    // Add OperatorName to each booking object
    const bookingsWithOperatorName = bookings.map(b => {
      const operator = operators.find(op => op.operatorId === b.operatorId);
      return {
        ...b,
        OperatorName: operator ? operator.operatorName : ""
      };
    });

    // Get headers including OperatorName
    const headers = Object.keys(bookingsWithOperatorName[0]);
    const csvRows = [
      headers.join(','), // header row
      ...bookingsWithOperatorName.map(b =>
        headers.map(h => `"${(b[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')
      )
    ];
    const csvContent = csvRows.join('\r\n');

    // Add timestamp to filename
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const downloadFileName =
      fileName ||
      `${bookingType || 'bookings'}_${timestamp}.csv`;

    // Create a blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <button className="themed-button" onClick={handleExport} disabled={!bookings || bookings.length === 0}>
      Export to CSV
    </button>
  );
};

export default ExportBookingsCSV;